import isEmpty from 'lodash/isEmpty';

import DisplayedTimeFormat from '@/components/DisplayedTimeFormat/DisplayedTimeFormat.vue';
import { RECEIVE_STATUS } from '@/utils/constants';

export default {
  name: 'OrderBlock',
  components: {
    DisplayedTimeFormat,
  },
  props: {
    order: {
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    contents() {
      const { order_contents: orderContents = [] } = this.order || {};
      return orderContents;
    },
    isCancelled() {
      const { status } = this.order || {};
      return status === RECEIVE_STATUS.CANCELED;
    },
    total() {
      return this.contents?.reduce((acc, { subtotal = 0 }) => acc + subtotal, 0) ?? 0;
    },
  },
  methods: {
    getOptionItemsText(options = []) {
      return options.map(({ items: optionItems }) => optionItems).flat().map(({ name }) => name).join(', ');
    },
    getSubtotal(items) {
      return items?.reduce((acc, { subtotal = 0 }) => acc + subtotal, 0) ?? 0;
    },
    hasNote({ note = '' } = {}) {
      return !isEmpty(String(note));
    },
    onCancelBtnClick() {
      const { uuid = '' } = this.order || {};
      this.$emit('cancel', { uuid });
    },
  },
};
